import React from 'react';

export const MainLogo = ({
  className = 'w-[255px] h-[197px]',
  variant = 'dark',
}) => {
  return (
    <img
      src={`/${variant === 'dark' ? 'main-logo.png' : 'main-logo-light.png'}`}
      alt="Gift Card Market"
      className={className}
      style={{
        objectFit: 'cover',
      }}
    />
  );
};
